import { useAuth } from '@/services/auth';
import { useEffect } from 'react';

export const LoginPage = () => {
    const { isAnonymous, user, loginWithRedirect } = useAuth();

    useEffect(() => {
        loginWithRedirect({
            redirectUri: `${window.location.origin}/`,
        });
    }, [isAnonymous, user]);

    return <></>;
};
